import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth }              from '@angular/fire/auth';
import { getFirebaseConfig }                 from './firebase.config';

export const firebaseProviders = [
  provideFirebaseApp(() => initializeApp(getFirebaseConfig())),
  provideAuth(() => getAuth()),
];